var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.wideScreen
    ? _c(
        "div",
        {
          staticStyle: {
            overflow: "hidden",
            padding: "10px",
            "padding-left": "0 !important",
          },
        },
        [
          _c(
            "div",
            {
              class: {
                "d-flex": true,
                "text-white": true,
                darkmode: _vm.isDarkMode,
                open: _vm.isOpen,
              },
              attrs: { id: "chat-stats" },
            },
            [
              _c(
                "div",
                { class: { open: !_vm.isOpen }, attrs: { id: "hide-noise" } },
                [
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.total"),
                      title: _vm.$t("message.totalBg").toLocaleLowerCase(),
                      value: _vm.stats.totalActive,
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.active"),
                      title: _vm.$t("message.activeBg").toLocaleLowerCase(),
                      value: _vm.isAdmin ? 0 : _vm.activeConversations.length,
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.waiting"),
                      title: _vm.$t("message.waitingBg").toLocaleLowerCase(),
                      value: _vm.stats.waiting,
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.late"),
                      title: _vm.$t("message.lateBg").toLocaleLowerCase(),
                      value: _vm.stats.late,
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.free"),
                      title: _vm.$t("message.freeBg").toLocaleLowerCase(),
                      value: _vm.stats.free,
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.chatbot"),
                      title: _vm
                        .$t("message.chatbotChatCount")
                        .toLocaleLowerCase(),
                      value: _vm.stats.chatbot,
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.maxCapacity"),
                      title: _vm
                        .$t("message.maxCapacityBg")
                        .toLocaleLowerCase(),
                      value: _vm.systemMaxChatCapacity + "",
                    },
                  }),
                  _vm._v(" "),
                  _c("a-statistic", {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "right",
                          theme: _vm.isDarkMode ? "light-border" : "google",
                        },
                        expression:
                          "{\n                    followCursor: true,\n                    placement: 'right',\n                    theme: isDarkMode ? 'light-border' : 'google',\n                }",
                      },
                    ],
                    attrs: {
                      content: _vm.$t("stats.pco"),
                      title: _vm.$t("message.pco").toUpperCase(),
                      value: Math.round(_vm.activeAgentRate) + "%",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "30px",
                    display: "flex",
                    "align-items": "center",
                  },
                  attrs: { id: "statPanelSlider" },
                  on: {
                    click: function ($event) {
                      return _vm.toggle()
                    },
                  },
                },
                [
                  _c("Arrows", {
                    class: { open: _vm.isOpen },
                    attrs: { id: "arrows", "data-v-step": "1" },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }